// extracted by mini-css-extract-plugin
export default {"card":"SelectorAgendaModal_card__uEUMI","cardText":"SelectorAgendaModal_cardText__g7CEF","infoText":"SelectorAgendaModal_infoText__VYYQb"};